module.exports = __webpack_public_path__ + "static/2-d100cea55768a201f5b8d06992eb61ec.jpg";